// DEV-MODE AUTH BYPASS - CLEANLY SEPARATED AND UNSHIPPABLE.
//
// `import.meta.env.DEV` is replaced by Vite at BUILD time (not runtime) with a literal `false` in
// a production build (`vite build` sets `import.meta.env.DEV = false`, `PROD = true`), so
// `isDevBypassEnabled()` is dead code eliminated from any production bundle - there is no runtime
// toggle that could turn this on in a deployed build. It exists only so a frontend developer can
// exercise the shell/roadmap without a live Entra tenant, and it is gated a second way on top of
// that: it also requires an explicit opt-in env var, so `npm run dev` does not silently bypass
// auth for everyone who has not set it. Recorded as a decision (decisions.md D-221).
export function isDevBypassEnabled(): boolean {
  return import.meta.env.DEV && import.meta.env.VITE_AUTH_DEV_BYPASS === "true";
}

/** The CallerContext a bypassed session presents locally; role is overridable for testing gates. */
export function devBypassCaller(role: string) {
  return {
    userKey: "00000000-0000-0000-0000-000000000001",
    principalId: "dev-bypass-principal",
    displayName: "Local Developer",
    role,
    teamCodes: [] as string[],
    correlationId: "dev-bypass",
  };
}
